<template>
  <DBox
    :id="'cmp-setting-identities-sidewindow_identities-classic_statement_email'"
    :addButton="false"
    :addLink="false"
    :rightMenu="[]"
    @menuClick="onRightMenuClick"
  >
        <!-- {
        text: 'Save',
        value: 'save',
      }, -->
    <div
      class="
        cmp-setting-identities-sidewindow_identities-classic_statement_email
      "
    >
     
        <TextField2
          :id="'sender_name'"
          :label="$t('sender_name')"
          v-bind="textFieldConfig"
          :value="text_element.sender_name"
          :placeholder="$t('sender_name')"
          @blur="(name, value) => onTextValueChange(name, value)"
        />
        <TextField2
          :id="'reply_to'"
          v-bind="textFieldConfig"
          :value="text_element.reply_to"
          :label="$t('reply_to')"
          :placeholder="$t('reply_to')"
          @blur="(name, value) => onTextValueChange(name, value)"
        />
        <TextField2
          :id="'subject_standard'"
          v-bind="textFieldConfig"
          :value="text_element.subject_standard"
          :label="$t('email_subject')"
          :placeholder="$t('email_subject')"
          @blur="(name, value) => onTextValueChange(name, value)"
        />
        <TextField2
          :id="'standard_text'"
          v-bind="textFieldConfig"
          :value="text_element.standard_text"
          :label="$t('email')"
          :placeholder="$t('email')"
          textarea
          :height="300"
          @blur="(name, value) => onTextValueChange(name, value)"
        />
        <Dropdown2
          :id="'include_amounts'"
          :label="$t('display_amount')"
          class="m2"
          :options="include_amountsTV"
          :selected="
            include_amountsTV.find(
              (b) => b.value == text_element.include_amounts
            )
          "
          :placeholder="$t('display_amount')"
         
          @selectedChange="(b) => onDropdownChange('include_amounts', b)"
        ></Dropdown2>
      
    </div>
  </DBox>
</template>
    <script>
import DBox from "@dtplugins/dbox/dbox";
import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";
import { tv, createTV } from "../../../../models/text-value.model";
export default {
  components: {},
  props: {
    invoiceProjectDetails: {
      type: Object,
    },
  },
  data() {
    return {
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: false,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur,
      }),
    };
  },

  computed: {
    text_element: function () {
      if (
        this.invoiceProjectDetails &&
        this.invoiceProjectDetails.invoice_project &&
        this.invoiceProjectDetails.invoice_project.text_elements
      ) {
        this.invoiceProjectDetails.invoice_project.text_elements.include_amounts =
          this.invoiceProjectDetails.invoice_project.text_elements
            .include_amounts
            ? this.invoiceProjectDetails.invoice_project.text_elements
                .include_amounts
            : "0";
      }
      return this.invoiceProjectDetails?.invoice_project?.text_elements || {};
    },
    include_amountsTV: function () {
      const options = [
        { value: "1", text: "Yes" },
        { value: "0", text: "No" },
      ];
      return createTV(options, "text", "value");
    },
  },
  methods: {
    onRightMenuClick: async function (menu) {
      if (menu == "save") {
        this.$emit("updated", {
          text_elements: this.text_element,
          invoice_project_id:
            this.invoiceProjectDetails?.invoice_project?.invoice_project_id,
        });
      }
    },
    onTextValueChange: function ({name, value}) {
      console.log({name,value})
      this.text_element[name] = value;
    },
    onDropdownChange: function (name, value) {
      this.text_element[name] = value.value;
    },
  },
};
</script>
    
    <style lang="scss">
.cmp-setting-identities-sidewindow_identities-classic_statement_email {
}
</style>
    